import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import StockMapView from "@/components/StockMapView";

export default function StockMap() {
  const nav = useNavigate();
  const [projects, setProjects] = useState([]);
  const [projectId, setProjectId] = useState("");
  const [blocks, setBlocks] = useState([]);
  const [currentBlockId, setCurrentBlockId] = useState(null);

  useEffect(() => {
    api.get("/projects").then(({ data }) => {
      setProjects(data);
      if (data.length) setProjectId(data[0].id);
    });
  }, []);

  useEffect(() => {
    if (!projectId) return;
    api.get(`/projects/${projectId}/stock-map`).then(({ data }) => {
      setBlocks(data);
      if (data.length) setCurrentBlockId(data[0].id);
    });
  }, [projectId]);

  return (
    <div className="space-y-6" data-testid="stock-map-page">
      <div>
        <h1 className="text-3xl font-bold text-slate-900 font-display">Kat Bazlı Stok Haritası</h1>
        <p className="text-slate-500 mt-1">Projedeki tüm blokları ve katları görsel olarak inceleyin.</p>
      </div>
      <div className="flex items-center gap-3 flex-wrap">
        <label className="text-sm text-slate-600">Proje</label>
        <select value={projectId} onChange={(e) => setProjectId(e.target.value)}
                className="input w-auto min-w-[280px]" data-testid="project-selector">
          {projects.map((p) => <option key={p.id} value={p.id}>{p.name}</option>)}
        </select>
      </div>
      <StockMapView blocks={blocks} currentBlockId={currentBlockId} setCurrentBlockId={setCurrentBlockId}
                    onUnitClick={(u) => nav(`/units/${u.id}`)} />
    </div>
  );
}
